import { InterestPeriodType } from '@shared/constants';
import { BridgingLoan, Period } from '@shared//models';

export function getFixedPeriodInYears(data: Period | BridgingLoan): number {
  return Number((Number(data.duration) / 12).toFixed());
}

export function comparePeriods(a: Period, b: Period): number {
  if (a.type === InterestPeriodType.Euribor) return 1;
  if (b.type === InterestPeriodType.Euribor) return -1;

  if (a.inactive === true) return 1;
  if (b.inactive === true) return -1;

  return getFixedPeriodInYears(a) - getFixedPeriodInYears(b);
}
